import Vue from 'vue'
//import "../../api/api.js"
//console.log(Vue.prototype.$ajax)
const config = {
  gobalUrl: "https://souquan.wang/api/"
}

//日志发表时间
const getDateDiff = function(dateTimeStamp) {
  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var halfamonth = day * 15;
  var month = day * 30;
  var year = day * 365;
  var now = new Date().getTime();
  var diffValue = now - dateTimeStamp;
  if (diffValue < 0) {
    //非法操作
    //return '数据出错';
    return '刚刚';
  }
  var yearC = diffValue / year;
  var monthC = diffValue / month;
  var weekC = diffValue / (7 * day);
  var dayC = diffValue / day;
  var hourC = diffValue / hour;
  var minC = diffValue / minute;
  var result;
  if (yearC >= 1) {
    result = parseInt(yearC) + '年以前';
  } else if (monthC >= 1) {
    result = parseInt(monthC) + '个月前';
  } else if (weekC >= 1) {
    result = parseInt(weekC) + '星期前';
  } else if (dayC >= 1) {
    result = parseInt(dayC) + '天前';
  } else if (hourC >= 1) {
    result = parseInt(hourC) + '小时前';
  } else if (minC >= 5) {
    result = parseInt(minC) + '分钟前';
  } else {
    result = '刚刚';
  }
  return result;
}

//现在距离未来多长时间
const getTimeDiff = function(time) {
  var today = new Date();
  var timerToday = today.getTime();
  var thatDayArray = time.split("-")
  var thatDAy = new Date(thatDayArray[0], thatDayArray[1] - 1, thatDayArray[2])
  var timerThatDay = thatDAy.getTime()
  var dayNumTime = timerThatDay - timerToday
  //获取天数

  var days = (Array(2).join(0) + Math.floor(dayNumTime / (24 * 3600 * 1000) + 1)).slice(-2);
  //获取小时数
  var leave1 = dayNumTime % (24 * 3600 * 1000)
  var hours = (Array(2).join(0) + Math.floor(leave1 / (3600 * 1000))).slice(-2);
  //获取分钟数
  var leave2 = leave1 % (3600 * 1000)
  var minutes = (Array(2).join(0) + Math.floor(leave2 / (60 * 1000))).slice(-2);
  //获取秒数
  var leave3 = leave2 % (60 * 1000)
  var second = (Array(2).join(0) + Math.floor(leave3 / (1000))).slice(-2);
  var diffTime = days + ":" + hours + ":" + minutes + ":" + second
  return diffTime

  //var y = time.getFullYear
  // var today = new Date();
  // var timerToday = day.getTime();//获取现在 距离 标准时间 多少毫秒
  //  document.write("现在时间:"+today+"<br />");
  //  //0居然代表了1月！我的天！ 我刚开始写了个3，看到输出是4月，我还以为电脑坏了。。。
  //  var thatDay = new Date(2017, 3, 10);
  // var timerThatDay = thatDay.getTime();//得到未来天 距离 标准时间 多少毫秒
  //  document.write("指定时间:" + thatDay + "<br />");
  // var dayNum = (timerThatDay - timerToday) / 1000 / 3600 / 24;
  // document.write("现在时间与指定时间距离:"+dayNum+" 天");
}

//登录


//获取积分

const scoreUserInfo = function(openID) {
  var scoreUserInfoList = {};
  Vue.prototype.$ajax.autoService
    .login("api/getUserScoreInfo.php?openID=" + openID).then((res) => {
      scoreUserInfoList = res.data[0];
      //return scoreUserInfoList;

    }, (res) => {
      console.log("失败")
    })

  return scoreUserInfoList
}



    //判断是否已经签到
    const isSign = function(eventName, openID) {
      Vue.prototype.$ajax.autoService.login('api/getEventInfo.php?eventName=' + eventName)
        .then((res) => {
          event = res.data[0]
          Vue.prototype.$ajax.autoService
            .login('api/getCountsAll.php?eventID=' + event.eventID + '&openID=' + openID).then((res => {
              //console.log(res);
              return res
            }))
        })
    }


    const subScore = function(eventName, openID, score) {
      Vue.prototype.$ajax.autoService.login('api/getEventInfo.php?eventName=' + eventName).then((res) => {
        var event = res.data[0];
        Vue.prototype.$ajax.autoService.login('api/addEventRecord.php?eventID=' + event.eventID + '&openID=' + openID + '&score=' + score + '&comment=')
          .then((res) => {})
      })
    }



    //签到
    const addScore = function(eventName, openID, cb, cf) {
      var score; //增加积分签到函数
      console.log("签到","heh")
      Vue.prototype.$ajax.autoService.login('api/getEventInfo.php?eventName=' + eventName)
        .then((res) => {
          var event = res.data[0]
          let maxTimesOneDay = event.maxTimesOneDay
          let maxTimes = event.maxTimes
          let minScore = event.minScore
          let eventScore = event.score
          Vue.prototype.$ajax.autoService
            .login('api/getCountsAll.php?eventID=' + event.eventID + '&openID=' + openID).then((res => {
              var timesAll = res.data * 1 || 0;
              if (timesAll < maxTimes * 1) {
                Vue.prototype.$ajax.autoService
                  .login('api/getCountsOneDay.php?eventID=' + event.eventID + '&openID=' + openID).then(res => {
                    var timesOneDay = res.data * 1 || 0;
                    if (timesOneDay < maxTimesOneDay  * 1) {
                      if (minScore * 1 == 0) { //
                        var score = eventScore
                      } else {
                        // // ////console.log('!0')
                        var score = Math.floor(Math.random() * (eventScore - minScore + 1) + minScore) + 1
                      }
                      //添加活动记录
                      Vue.prototype.$ajax.autoService
                        .login('api/addEventRecord.php?eventID=' + event.eventID + '&openID=' + openID + '&score=' + score + '&comment=').then((res) => {
                          typeof cb == "function" && cb(score)
                        })
                    } else {
                      //已达到活动每天最大加分次数
                      let errorString = '已达到每日领取上限，亲，明天再来领券币吧。'
                      typeof cf == "function" && cf(eventName, maxTimesOneDay, errorString)
                    }
                  })
              } else {
                //已达到活动最大加分次数
                let errorString = '您已领过券币了。亲，请继续关注我们的其他的活动吧。'
                typeof cf == "function" && cf(eventName, maxTimesOneDay, errorString)
              }
            }))
        })
    }
    export {
      config,
      getDateDiff,
      getTimeDiff,
      addScore,
      scoreUserInfo,
      isSign,
      subScore,
      sendBuyScoreMallGoodTempleteMessage
    }



// WEBPACK FOOTER //
// ./src/common/js/common.js